export default __webpack_public_path__ + "static/media/Small_printing_rules_inches.85955a3b.pdf";